module.exports = __webpack_public_path__ + "img/title_uk.cd87b09e.svg";